import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { LdCard } from "@liquid/react";

import { pxToRem } from "@src/utils";

const DisabledCard = css`
  --ld-card-bg-col: var(--ld-col-neutral-050);
  --ld-shadow-stacked: none;
  cursor: default;
`;

const ClickableCard = css`
  cursor: pointer;
`;

const Card = styled(LdCard, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled?: boolean }>`
  --ld-card-padding-sm: ${pxToRem(20)};

  ${({ onClick }) => onClick && ClickableCard}

  ${({ disabled }) => disabled && DisabledCard}
  
  &[data-transparent="true"] {
    --ld-card-bg-col: rgba(0, 0, 0, 0.05);

    ::before {
      box-shadow: none;
    }
  }
`;

export { Card };
